export default __webpack_public_path__ + "static/media/ilustracao-exclamacao-fique-atento.e898ee98.svg";